import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, Form, Input, Button, Alert, Spin } from 'antd';
import { useLocation } from 'react-router-dom';

import AuthStore from 'common/authStore';
import { CuriousLogo, LoginLeftBg, SfsDark } from 'assets';
import { fetchUserDetails, fetUserRole, setUserData } from './auth.action';
import { AUTH_STATUS } from 'common/constants';

import Loader from 'components/ui/Loader';
import Reports from 'containers/Reports';

import './styles.scss';

function Login({ children }) {
  const dispatch = useDispatch();
  const token = AuthStore.accessToken;
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const rkey = query.get('key');

  const { isError, isAuthorized, loading, tokenExpired } = useSelector((state) => state.auth);

  useEffect(() => {
    if (token) {
      dispatch(setUserData(token));
      dispatch(fetUserRole());
    }
    // eslint-disable-next-line
  }, [token, tokenExpired]);

  const onFinish = (values) => {
    const finalPayload = {
      ...values,
      userInfo: {
        ip: 'string',
        city: 'string',
        country: 'string',
        browserName: 'string'
      }
    };
    dispatch(fetchUserDetails(finalPayload));
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Login failed:', errorInfo);
  };

  const submitForm = () => {
    sessionStorage.removeItem('prevroute');
    console.log('submit login form');
  };

  // Handle query-based redirect
  if (rkey) {
    return <Reports isReqiredauth={false} rkey={rkey} />;
  }

  // If already authorized, show children
  if (isAuthorized === AUTH_STATUS.Authorized) {
    return children;
  }

  // Default: show login form
  return (
    <div className="login-container" onClick={submitForm}>
      {loading && <Loader />}
      <Row className="login-row">
        <Col xs={0} md={12} className="login-leftbg">
          <img src={LoginLeftBg} alt="login left bg" />
        </Col>
        <Col xs={24} md={12} className="login-right">
          <div>
            <div className="logosection">
              <img src={SfsDark} alt="logo" className="leftlogo" />
              <img src={CuriousLogo} alt="logo" className="rightlogo" />
            </div>
            <div className="login-content">
              <h3>Please enter your credentials</h3>
              {/* <p>Welcome back!</p> */}
              {isError && (
                <Alert
                  style={{ marginBottom: 15 }}
                  type="error"
                  message="The username or password is incorrect"
                />
              )}
              <Form
                name="login"
                className="login-form"
                size="large"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout="vertical"
                autoComplete="off"
              >
                <Form.Item
                  label="Username"
                  name="userName"
                  rules={[{ required: true, message: 'Please input your username!' }]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Password"
                  name="key"
                  rules={[{ required: true, message: 'Please input your password!' }]}
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item>
                  <Button block type="primary" htmlType="submit">
                    {loading ? <Spin /> : 'Log in'}
                  </Button>
                </Form.Item>
              </Form>
              <div className="copywritelogin">
                &copy; 2026 Curious Insights | All Rights Reserved
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Login;
